import React from 'react';
import { reduxForm, Field } from 'redux-form';

import InputField from 'components/InputField';
import SelectField from 'components/SelectField';
import CheckboxField from 'components/CheckboxField';
import FormError from 'components/FormError';
import states from 'helpers/states';

import styles from './styles.module.scss';

const ActivateSubModalForm = ({
  sub,
  isAgentOrAdminOrManager,
  user,
  handleSubmit,
  error,
}) => {
  const showEsim = sub?.vendor === 'tsp';
  const isPinRequired = user?.acl_group_name !== 'BUSINESS';
  return (
    <form onSubmit={handleSubmit}>
      <div className={styles.row}>
        <div className={styles.item}>
          <Field
            component={InputField}
            name="address1"
            label="Address Line 1*"
          />
        </div>
        <div className={styles.item}>
          <Field
            component={InputField}
            name="address2"
            label="Address Line 2"
          />
        </div>
        <div className={styles.item}>
          <Field component={InputField} name="city" label="City*" />
        </div>
        <div className={styles.item}>
          <Field
            component={SelectField}
            name="state"
            label="State*"
            empty="Choose a state"
            options={states.map((state) => [state.abbreviation, state.name])}
          />
        </div>
        <div className={styles.item}>
          <Field component={InputField} name="zip_code" label="Zip Code*" />
        </div>
        <div className={styles.item}>
          <Field
            component={InputField}
            name="pin"
            label={`Pin${isPinRequired ? '*' : ''}`}
          />
        </div>
        {showEsim && (
          <div className={styles.item}>
            <Field component={CheckboxField} name="esim" label="eSIM" />
          </div>
        )}
      </div>
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-primary">Activate Subscription</button>
    </form>
  );
};

const validate = (values, { user }) => {
  let errors = {};

  if (!values.address1) {
    errors.address1 = 'Required';
  }

  if (!values.city) {
    errors.city = 'Required';
  }

  if (!values.state) {
    errors.state = 'Required';
  }

  if (!values.zip_code) {
    errors.zip_code = 'Required';
  }

  if (!values.pin && user?.acl_group_name !== 'BUSINESS') {
    errors.pin = 'Required';
  }

  return errors;
};

export default reduxForm({
  form: 'activateSub',
  validate,
  enableReinitialize: true,
})(ActivateSubModalForm);
